
import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";
import BlockImage from "../../Block/BlockImage";

function Clustering() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>Clustering</BlockTitle>
          {/* <BlockSubtitle>Autonomous Camera Drones for Interactive Experiences in Extended Reality Telepresence Applications with enhanced Naturalness</BlockSubtitle> */}
        </BlockContent>
        <BlockContent>
          <BlockText>This lecture covers the fundamentals of clustering, with a particular focus on the k-means algorithm and methods for evaluating clustering results.</BlockText>
        </BlockContent>
      </Block>


      <Block gridTemplateColumns="1200px">
        <BlockContent>
              <iframe
      src={`${process.env.PUBLIC_URL}/pdf/CLU.pdf`}
      width="100%"
      height="600px"
      style={{ border: "none" }}
      title="PDF Anzeige"
    />
        </BlockContent>
      </Block>

        <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent width="10%" textAlign="center" color="grey" fontStyle="italic">
          <BlockButton width="150px" onClick={() => window.open("https://colab.research.google.com/github/hpotechius/ClusteringExercise/blob/main/main.ipynb")}>
          <img className="BlockButton-img" src={process.env.PUBLIC_URL + '/images/base/googlecolab.webp'} alt=""/> Exercise</BlockButton>
        </BlockContent>
        <BlockContent width="10%" textAlign="center" color="grey" fontStyle="italic">
          <BlockButton width="150px" onClick={() => window.open("https://github.com/hpotechius/ClusteringExercise")}>
          <img className="BlockButton-img" src={process.env.PUBLIC_URL + '/images/base/Github.webp'} alt=""/> Exercise</BlockButton>
        </BlockContent>
      </Block>


      <Footer/>
    </div>
  );
}

export default Clustering;